import { lazyCss, lazyHead } from "@op/puck";
import { publicEnv } from "./env";
import globalCss from "../styles/global.css?url";
import printCssUrl from "../styles/print.css?url";
import youtubeEmbedCssUrl from "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css?url";

export function loadCss(
  organizationSlug: string,
  projectSlug: string,
  renderMedium: string
) {
  const links: { rel: string; href: string; id?: string; type?: string }[] = [
    ...lazyHead(
      organizationSlug,
      projectSlug,
      publicEnv.VITE_DEFAULT_ORGANIZATION_SLUG,
      publicEnv.VITE_DEFAULT_PROJECT_SLUG
    ),
    ...lazyCss(
      organizationSlug,
      projectSlug,
      publicEnv.VITE_DEFAULT_ORGANIZATION_SLUG,
      publicEnv.VITE_DEFAULT_PROJECT_SLUG,
      renderMedium as "print" | "screen"
    ),
    { rel: "stylesheet", id: "global-styles", href: globalCss },
    {
      rel: "stylesheet",
      id: "youtube-embed-styles",
      href: youtubeEmbedCssUrl,
    },
    { rel: "icon", type: "image/svg+xml", href: "/vite.svg" },
  ];

  if (renderMedium === "print") {
    links.push({
      rel: "stylesheet",
      id: "print-css",
      href: printCssUrl,
    });
  }

  return links;
}
